import Lockr from 'lockr';
import config from '@/config';
import axios from 'axios';
/*
// Refreshes the access token if it is older than 10 minutes
*/
export default function ({ next, router }) {
  const refresh_token = Lockr.get('refresh_token');
  const tokenInterval = Lockr.get('tokenInterval');

  // Current time - 10 min
  const tenMinutesAgo = new Date(new Date().getTime() - 10 * 60 * 1000);

  async function newToken() {
    try {
      let { data } = await axios.post(
        config.client_api_endpoint + '/oauth/token',
        'grant_type=refresh_token&refresh_token=' + refresh_token,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-TenantName': 'backend'
          }
        }
      );

      // Sets new tokens and new interval.
      Lockr.set('refresh_token', data.refresh_token);
      Lockr.set('token', 'Bearer ' + data.access_token);
      Lockr.set('tokenInterval', new Date().getTime());
    } catch (e) {
      console.error('error', e);
      this.error = e.response;
    }
  }

  /*
  // If none are present, continue to next page
  // Side note: 
  // When making an API request and it returns 401 
  // The user gets automatically logged off, so no need for extra redundancy.
  */
  if (!tokenInterval && !refresh_token) {
    return next();
  }

  // Creates a new tokenInterval if none are present
  if (!tokenInterval && refresh_token) {
    Lockr.set('tokenInterval', new Date().getTime());
    return next();
  }
  // If tokenInterval is older than 10 min, create new access token.
  if (new Date(tokenInterval).getTime() < new Date(tenMinutesAgo).getTime()) {
    newToken();
  }

  return next();
}
